import { Component, Input, OnInit } from '@angular/core';
import { EmpresasService } from '../../superadmin/services/empresas.service';

@Component({
  selector: 'app-configuracoes-modulo-caixa',
  templateUrl: './configuracoes-modulo-caixa.component.html',
  styleUrls: ['./configuracoes-modulo-caixa.component.scss']
})
export class ConfiguracoesModuloCaixaComponent implements OnInit {
  @Input() empresa: any = {};

  configCaixa: any = {};
  mensagemSucessoCaixa = '';
  mensagemErro: any;
  salvando: any;

  constructor(
    private empresaService: EmpresasService
  ) {}

  ngOnInit(): void {
    // Mantém o mesmo padrão: pega do objeto da empresa ou cria vazio
    this.configCaixa = this.empresa.configuracoesCaixa || this.empresa.caixa || {};

    // Defaults (para evitar undefined no template)
    if (this.configCaixa.ativo === undefined || this.configCaixa.ativo === null) {
      this.configCaixa.ativo = true;
    }
    if (!this.configCaixa.modoOperacao) {
      this.configCaixa.modoOperacao = 'UNICO'; // 'OPERADOR' | 'UNICO'
    }
  }

  onSubmitConfigCaixa() {
    this.mensagemSucessoCaixa = '';
    this.mensagemErro = '';
    this.salvando = true;

    this.configCaixa.ativo = true

    // Se desativar o módulo, opcionalmente mantém modoOperacao ou reseta
    // (deixei mantendo para não perder a preferência do cliente)
    this.empresaService.salveConfigCaixa(this.empresa, this.configCaixa)
      .then((resp) => {
        // garante id caso seja criação
        if (!this.configCaixa.id && resp?.id) {
          this.configCaixa.id = resp.id;
        }

        // opcional: espelha no objeto empresa (ajuda em telas que usam empresa.*)
        this.empresa.configuracoesCaixa = this.configCaixa;

        this.salvando = false;
        this.mensagemSucessoCaixa = 'Configurações de caixa salvas com sucesso!';
      })
      .catch((erro) => {
        this.salvando = false;
        alert(erro);
      });
  }
}
